import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';

import { ClipboardActions, ToastActions } from '@app/store/actions';

@Injectable()
export class ClipboardEffects {
  readonly #actions$ = inject(Actions);

  addItems$: any = createEffect((): any =>
    this.#actions$.pipe(
      ofType(ClipboardActions.addItems),
      switchMap(({ value }: { value: { items: any; action: string } }) => [
        ToastActions.addToastInfo({
          message:
            value.items.length > 1
              ? `clipboard.${value.action}.saveAll`
              : `clipboard.${value.action}.saveOne`,
        }),
      ]),
    ),
  );
}
